import { atom } from "recoil";

export const createRfidDrawerState = atom({
  key: "createRfidDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
